import { styled } from '@linaria/react';

import { Captions, SubHeadline } from '~components/Typography';
import { ButtonIconSecondary } from '~shared/ui/atoms/Buttons/ButtonSecondary/Icon';
import { lineClamp } from '~theme/snippets';

export const Title = styled(SubHeadline)`
	grid-area: title;
	word-break: break-word;
`;

export const Description = styled(Captions)`
	${lineClamp(2)};
	overflow: hidden;
	grid-area: text;
	line-clamp: 2;
	text-overflow: ellipsis;
	word-break: break-word;
`;

export const TotalMessages = styled.div`
	position: absolute;
	right: 8px;
	bottom: 8px;
	display: flex;
	align-items: center;
	gap: var(--gap-l);
`;

export const MessagesButton = styled(ButtonIconSecondary)`
	position: absolute;
	top: 0.8rem;
	right: 0.8rem;
`;

export const StyledGridItem = styled.div`
	position: relative;
	display: flex;
	& > * {
		flex-grow: 1;
	}
`;
